import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { LineSorterTool } from "../components/LineSorterTool";
import { LsBreadcrumb } from "../components/LsBreadcrumb";
import { LsExplainer } from "../components/LsExplainer";

export function LineSorterPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <LsBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.ls_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.ls_intro()}
          </p>
        </header>

        <LineSorterTool />

        <LsExplainer
          howTo={m.ls_howto()}
          faqs={[
            { q: m.ls_faq1_q(), a: m.ls_faq1_a() },
            { q: m.ls_faq2_q(), a: m.ls_faq2_a() },
            { q: m.ls_faq3_q(), a: m.ls_faq3_a() },
            { q: m.ls_faq4_q(), a: m.ls_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
